// extracted by mini-css-extract-plugin
export default {"stepTextWrapper":"a3o48"};